/**
 * Permission codes the Period Control screen (FSD 1.2.7, F-6.007) declares an
 * interest in.
 *
 * They are the same dot-strings `web/src/modules/org/permissions.ts` carries
 * (`ORG_PERMISSIONS.fiscalRead`, `periodClose`, `periodPermanentClose`, …) —
 * re-exported under this module's own name so the screen reads its authority
 * from beside itself, the way every other `enterprise/<feature>/permissions.ts`
 * does, without a second spelling of any code.
 *
 *  - `read`             lists ledgers, calendars and periods.
 *  - `manage`           generates another fiscal year of periods.
 *  - `close`            soft-closes, closes and reopens (`gl.period.close`,
 *                       step-up MFA server-side).
 *  - `permanentClose`   requests the terminal, dual-approved state. A separate
 *                       authority, never implied by `close`.
 *  - `ledgerRead`       lets the ledger picker list ledgers.
 */

import { ORG_PERMISSIONS } from '@/modules/org/permissions'

export const PERIOD_PERMISSIONS = {
  read: ORG_PERMISSIONS.fiscalRead,
  manage: ORG_PERMISSIONS.fiscalManage,
  close: ORG_PERMISSIONS.periodClose,
  permanentClose: ORG_PERMISSIONS.periodPermanentClose,
  ledgerRead: ORG_PERMISSIONS.ledgerRead,
} as const
